import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  IProviderName,
} from '@shared/constants'

import withNetwork from './withNetwork'
import devconsole from '../utils/devconsole'
import routerSelectors from '../store/selectors/router'

const withProviderName = (): IProviderName => {
  const network = withNetwork()
  const params = useSelector(routerSelectors.params)
  const providerName = useMemo(() => {
    let providerName = network.providers[0]
    if(params.provider && network.providers.indexOf(params.provider) >= 0) {
      providerName = params.provider as IProviderName
    }
    devconsole.log(`provider selector: ${providerName}`)
    return providerName
  }, [
    network,
    params.provider,
  ])
  return providerName
}

export default withProviderName